import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { ElementType, HTMLAttributes, forwardRef } from "react";

export interface ContainerProps extends HTMLAttributes<HTMLElement> {
  fluid?: boolean | string | "sm" | "md" | "lg" | "xl" | "2xl";
  as?: ElementType;
}

const Container = forwardRef<HTMLElement, ContainerProps>((props, ref) => {
  const { className, fluid, as: Component = "div", ...rest } = props;

  return (
    <Component
      {...rest}
      ref={ref}
      className={twMerge(
        clsx("container mx-auto", {
          "max-w-full": fluid === true,
          "fixed-sm:max-w-full": fluid === "sm",
          "fixed-md:max-w-full": fluid === "md",
          "fixed-lg:max-w-full": fluid === "lg",
          "fixed-xl:max-w-full": fluid === "xl",
          "2xl:max-w-full": fluid === "2xl",
        }),
        className
      )}
    />
  );
});

export default Container;
